<template>
    <div>
        <label>
            Address
        </label>

        <gmap-autocomplete
            class="form-control"
            :value="address.address"
            placeholder="Type an address..."
            @place_changed="onPlaceChanged">
        </gmap-autocomplete>

        <div class="row">
            <!-- <div class="col-sm-6">

                <b-form-input
                        type="text"
                        v-model="address_components.street_number"
                        placeholder="Street Number">
                </b-form-input>

                <b-form-input
                        type="text"
                        v-model="address_components.line_one"
                        placeholder="Line One">
                </b-form-input>

                <b-form-input
                        type="text"
                        v-model="address_components.line_two"
                        placeholder="Line Two">
                </b-form-input>

                <b-form-input
                        type="text"
                        v-model="address_components.line_three"
                        placeholder="Line Three">
                </b-form-input>

                <b-form-input
                        type="text"
                        v-model="address_components.town_city"
                        placeholder="Town/City">
                </b-form-input>

                <b-form-input
                        type="text"
                        v-model="address_components.county"
                        placeholder="County">
                </b-form-input>

                <b-form-input
                        type="text"
                        v-model="address_components.country"
                        placeholder="Country">
                </b-form-input>

                <b-form-input
                        type="text"
                        v-model="address_components.postcode"
                        placeholder="Postcode">
                </b-form-input>

            </div> -->
            <div class="col-12">
                <gmap-map
                        :center="map.center"
                        :zoom="12"
                        ref="map"
                        @center_changed="onMapCenterChanged"
                        @idle="sync"
                        :class="map.class">
                    <gmap-marker v-if="map.marker.position" :position="map.marker.position"></gmap-marker>
                </gmap-map>
            </div>
        </div>




    </div>
</template>

<script>
    export default {
        props: {
            addressObject: {
                default: null
                /*
                    {
                        address: string,
                        lat: float,
                        lng: float
                    }
                */
            }
        },
        
        data() {
            return {
                address: {
                    address: "",
                    lat: null,
                    lng: null,
                },
                // address_components: {
                //     street_number: "",
                //     line_one: "",
                //     line_two: "",
                //     line_three: "",
                //     town_city: "",
                //     county: "",
                //     country: "",
                //     postcode: ""
                // },
                map: {
                    center: null,
                    reported_center: {
                        lat: 1.32,
                        lng: 103.8
                    },
                    marker: {
                        position: false
                    },
                    class: "map-container",
                    x: 2
                },
                
                // component_references: {
                //     'street_number': 'street_number',
                //     'route': 'line_one',
                //     'locality': 'line_two',
                //     'postal_town': 'town_city',
                //     'administrative_area_level_2': 'county',
                //     'administrative_area_level_1': 'country',
                //     'country': 'country',
                //     'postal_code': 'postcode'
                // }
            }
        },

        methods: {
            sync() {
                this.map.center = this.map.reported_center;
            },
            
            onPlaceChanged(place) {
                if (place.hasOwnProperty('geometry')) {
                    // failed requests return { name: "" } with name set to the 
                    // value of the request
                    this.clearAddress();
                    this.setAddress(place.name + ', ' + place.formatted_address, place.address_components, place.geometry.location.lat(), place.geometry.location.lng());
                    this.setMapMarker(place.geometry.location.lat(), place.geometry.location.lng());
                    this.setMapCenter(place.geometry.location.lat(), place.geometry.location.lng());
                    this.sync();
                }
            },

            clearAddress() {
                for (var key in this.address) {
                    this.address[key] = "";
                }
            },

            setAddress(formatted_address, address_components, lat, lng) {
                this.address.address = formatted_address;
                this.address.lat = lat;
                this.address.lng = lng;
                // this.populateComponents(address_components);
                this.$emit('changed', this.address);
            },
            
            // populateComponents(components) {
            //     for (var component of components) {
            //         if (this.component_references.hasOwnProperty(component.types[0])) {
            //             // if there is an entry in component_references that matches this address component's type - i.e., 'country'

            //             var ref_index = this.component_references[component.types[0]];
            //             // get the translated getAll to use on this.address. i.e., for "postal_town", use "town_city" to do this.address['town_city'] = ...
                        
            //             this.address_components[ref_index] = component.long_name;
            //         }
            //     }
            // },

            onMapCenterChanged(lat_lng) {
                this.setMapCenter(lat_lng.lat(), lat_lng.lng());
            },

            setMapCenter(lat, lng) {
                this.map.reported_center = {
                    lat: lat,
                    lng: lng
                }
            },

            setMapMarker(lat, lng) {
                this.map.marker.position = {
                    lat: lat, 
                    lng: lng
                }
            }
        },

        created() {
            this.sync();
        },

        mounted() {
            if (this.addressObject) {
                this.address = this.addressObject;
                this.setMapCenter(this.addressObject.lat, this.addressObject.lng);
                this.setMapMarker(this.addressObject.lat, this.addressObject.lng);
            }
        }
    }
</script>

<style lang="scss">
    input {
        margin-bottom: 10px!important;
    }

    // input:disabled {
    //     background-color: white!important;
    // }

    .pac-container.pac-logo:after,
    .pac-logo:after {
        height: 0!important;
        background-image: none!important;
    }

    .vue-map-container {
        height: 500px;
        width: 100%;
        display: inline-block;
        margin-bottom: 10px;
    }
</style>